import React, { useEffect, useState } from 'react';
import PecasEnEquipamentoTable from './PecasEnEquipamentoTable';
import { SquarePlus } from 'lucide-react';
import {
  IconButton,
  Tooltip,
  ListItem,
  Typography,
  ListItemSuffix,
} from '@material-tailwind/react';
import { ChevronDown } from 'lucide-react';
import { AddModalPecas } from '../Modal/AddModalPecas';

const EquipsComponents = ({ item }) => {
  const [modal, setModal] = useState(false);
  const [table, setTable] = useState(false);

  useEffect(() => {
    setTable(false);
  }, [item]);

  const handleModel = () => {
    setTable(false);
    setModal(!modal);
  };
  const handlTable = () => {
    setTable(!table);
  };

  return (
    <ListItem
      className="py-0 pr-1 pl-4 flex flex-col dark:hover:bg-opacity-5  dark:focus:bg-inherit hover:bg-transparent focus:bg-transparent active:bg-transparent uppercase"
      ripple={false}
    >
      <div className="w-full flex items-center border  border-black p-2 rounded-md bg-lightButtonArvore dark:bg-darkButtonColor  text-black shadow-sm shadow-black">
        <Typography
          variant="h6"
          className="font-bold  dark:text-darkText w-full overflow-hidden text-ellipsis whitespace-nowrap
        "
          onClick={handlTable}
        >
          {item.nome}
        </Typography>
        <Typography
          className="font-bold text-black dark:text-white text-xs ml-5
        "
          onClick={handlTable}
        >
          {item.tag}
        </Typography>
        <ListItemSuffix className="flex m-0" onClick={handleModel}>
          <Tooltip content="Adicionar ">
            <IconButton variant="text">
              <SquarePlus className="dark:opacity-60 dark:text-darkText text-black" />
            </IconButton>
          </Tooltip>
        </ListItemSuffix>

        <ListItemSuffix onClick={handlTable}>
          <IconButton variant="text">
            <ChevronDown className="h-4 w-4 dark:text-darkText text-black" />
          </IconButton>
        </ListItemSuffix>
      </div>
      {table && <PecasEnEquipamentoTable id={item.id} />}
      <AddModalPecas modal={modal} handleModal={handleModel} item={item} />
    </ListItem>
  );
};

export default EquipsComponents;
